import { CustomAuthMethodInput } from '@pypestream/api-services';
import {
  BlockList,
  Grid,
  GridCell,
  PageSection,
  Spacer,
  TextSubtitle,
  TextTitle,
} from '@pypestream/design-system';
import { TranslationComponent } from '@pypestream/translations';
import { FC } from 'react';
import { UseFormReturn } from 'react-hook-form';
import { CreateOrganizationFields, Users } from './create-organization-fields';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type ReturnFormType = UseFormReturn<any, unknown, undefined>;

type OrganizationDetailsPropsType = {
  form: ReturnFormType;
  parentId: string;
  users: Users;
  isAdminRole: boolean;
  isEdit?: boolean;
  customAuthMethods?: CustomAuthMethodInput[];
  hasInflightNetworkRequest?: boolean;
};

const { OrganizationNameField, OrganizationIconField, OrgLoginMethodsField } =
  new CreateOrganizationFields();

export const OrganizationDetails: FC<OrganizationDetailsPropsType> = ({
  form,
  isAdminRole,
  isEdit,
  hasInflightNetworkRequest,
}) => {
  return (
    <>
      <PageSection size="small">
        <TextTitle test-id="organization-details-subtitle" size="xsmall">
          <TranslationComponent i18nKey="manager/preferences:general.details">
            Details
          </TranslationComponent>
        </TextTitle>
        <Spacer size="large" />
        <BlockList gutter="large">
          <Grid alignItems="center">
            <GridCell xsmall="12" medium="3">
              <TextSubtitle
                test-id="organization-name"
                size="small"
                variant="secondary"
              >
                <TranslationComponent i18nKey="manager/organizations:createOrg.name">
                  Name*
                </TranslationComponent>
              </TextSubtitle>
            </GridCell>
            <GridCell xsmall="12" medium="9">
              <OrganizationNameField
                _form={form}
                disabled={!isAdminRole || !!hasInflightNetworkRequest}
              />
            </GridCell>
          </Grid>

          <Grid alignItems="center">
            <GridCell xsmall="12" medium="3">
              <TextSubtitle
                test-id="organization-icon"
                size="small"
                variant="secondary"
              >
                <TranslationComponent i18nKey="manager/organizations:createOrg.icon">
                  Icon
                </TranslationComponent>
              </TextSubtitle>
            </GridCell>
            <GridCell xsmall="12" medium="9">
              <OrganizationIconField
                form={form}
                readOnly={!isAdminRole || !!hasInflightNetworkRequest}
              />
            </GridCell>
          </Grid>
        </BlockList>
      </PageSection>
      <PageSection size="small">
        <TextTitle
          test-id="organization-details-login-methods-subtitle"
          size="xsmall"
        >
          <TranslationComponent i18nKey="manager/organizations:createOrg.loginMethods">
            Login Methods
          </TranslationComponent>
        </TextTitle>
        <TextSubtitle size="xsmall" variant="tertiary">
          {`Activate login methods for your organization. Once active, users can set up login methods via My Account > Login Methods > Set up.`}
        </TextSubtitle>
        <Spacer size="large" />
        <Grid>
          <OrgLoginMethodsField
            disabled={!isAdminRole || !!hasInflightNetworkRequest}
            _form={form}
            isEdit={isEdit}
          />
        </Grid>
      </PageSection>
    </>
  );
};
